export default "/_next/static/images/wwtvimage-e5114b8c840b131a1f25de7edd60e03a.jpg";